import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Toast } from 'ngx-toastr';

import { SharedUtilToastModule, ToastAnimation } from '@mode/shared/util-toast';

@Component({
  standalone: true,
  selector: 'mode-export-dataset-limit-exceed',
  imports: [SharedUtilToastModule],
  templateUrl: './export-dataset-limit-exceed.component.html',
  styleUrls: ['./export-dataset-limit-exceed.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [ToastAnimation],
})
export class ExportDatasetLimitExceedComponent extends Toast {}
